import { defineStore } from 'pinia'
import ClassroomRepository from '~~/repositories/Creche/ClassroomRepository.js'

export const useClassroomsStore = defineStore('classrooms', {
    state: () => ({
        classrooms: [],
        selectedClassroom: null,
        classroomFilters: {}
    }),

    actions: {
        fetchClassrooms (crecheUuid = null) {
            return ClassroomRepository.index(null, crecheUuid)
                .then((response) => {
                    this.classrooms = response.data
                })
        },
        selectClassroom (classroom) {
            this.selectedClassroom = classroom
        },
        setClassroomFilter (key, value) {
            this.classroomFilters[key] = value
        }
    }
})
